import React from 'react'
import { cx } from '@emotion/css'
import { Field } from 'redux-form'

import { Notification, emailText, requiredField } from '@offerzen/pinata-shame'

import TextInput from '../TextInput'
import FormLabel from '../FormLabel'
import EmailInput from '../EmailInput'
import Button from '../Button'
import Checkbox from '../Checkbox'
import SingleAutocomplete from '../SingleAutocomplete'
import styles from './styles'

const validators = {
  required: requiredField('This field is required.'),
  email: emailText('You need to fill in a valid email address'),
  requiredBasedInLocation: (value, allValues) => {
    const validationMessage = 'You need to select your current location.'
    if (!value) {
      return validationMessage
    }
    if (!allValues.based_in_location) {
      return validationMessage
    }
    if (!allValues.based_in_location.geoapify_place_id) {
      return validationMessage
    }
    if (value !== allValues.based_in_location.inputted_address) {
      return validationMessage
    }
    return undefined
  },
}

const ConfirmationForm = ({ onSubmit, places, candidate, addCity, searchCities, clearData, clearPlace, loading }) => (
  <form onSubmit={onSubmit}>
    <div className={styles.nameFieldsContainer}>
      <div className={cx(styles.nameField, styles.firstNameField)}>
        <FormLabel label="First name" htmlFor="first_name" />
        <Field
          id="first_name"
          name="first_name"
          className={cx(styles.nameFieldInput, styles.textInput)}
          validate={validators.required}
          component={TextInput}
          theme="primary"
          placeholder="Enter your first name"
        />
      </div>

      <div className={cx(styles.nameField, styles.lastNameField)}>
        <FormLabel label="Last name" htmlFor="last_name" />
        <Field
          id="last_name"
          name="last_name"
          className={cx(styles.nameFieldInput, styles.textInput)}
          validate={validators.required}
          component={TextInput}
          placeholder="Enter your last name"
        />
      </div>
    </div>

    <FormLabel label="Email" htmlFor="email" />
    <Field
      id="email"
      name="email"
      className={cx(styles.inputReset, styles.textInput)}
      type="email"
      validate={validators.email}
      component={EmailInput}
      value={candidate.email}
      disabled
    />

    <FormLabel label="Current location" htmlFor="location" />
    <Field
      id="location"
      name="location"
      placeholder="Search for your city"
      data={places.data}
      normalizer={suggestion => suggestion.name}
      onChange={clearPlace}
      onSelect={suggestion => addCity(suggestion)}
      onDataFetch={value => searchCities(value)}
      onDataClear={() => clearData()}
      className={cx(styles.textInput, styles.searchInput)}
      errorClassName={styles.searchError}
      loading={places.fetching}
      validate={validators.requiredBasedInLocation}
      component={SingleAutocomplete}
    />

    <Field
      id="opt_into_marketing"
      name="opt_into_marketing"
      component={Checkbox}
      theme="primary"
      label={
        <span>
          Let me know about job opportunities on OfferZen and other tech community updates. This includes upcoming tech events and content
          from our blog. Unsubscribe any time.
        </span>
      }
      className={styles.checkbox}
    />

    {candidate && candidate.error && (
      <Notification className={styles.errorNotification} theme="error">
        {candidate.error}
      </Notification>
    )}

    <Button type="submit" loading={loading} className={styles.button} size="medium" label="Confirm details" />
  </form>
)

export default ConfirmationForm
